var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{attrs:{"block":""},on:{"click":_vm.voltar}},[_vm._v("Cancelar\r\n  ")])
}
var staticRenderFns = []

export { render, staticRenderFns }